import ProductDetailInfo, { ProductDetailInfoProps } from "./ProductDetailInfo";

export { ProductDetailInfo, ProductDetailInfoProps };

export default ProductDetailInfo;
